import { Stack } from '@/components/layout/stack';
import Text from '@/components/ui/text/text';
import { useScaling } from '@/hooks/use-scaling';
import { colors } from '@/theme/colors';
import { memo } from 'react';
import { StyleSheet } from 'react-native';

const StatCard = memo(
  ({ value, label, compact }: { value: number; label: string; compact?: boolean }) => {
    const { scale } = useScaling();
    return (
      <Stack
        flex={compact ? undefined : 1}
        width={compact ? scale(112) : undefined}
        height={compact ? scale(40) : scale(48)}
        backgroundColor="white"
        borderRadius={scale(4)}
        align="center"
        justify="center"
        paddingX={compact ? scale(8) : undefined}
        paddingBottom={scale(4)}>
        <Text variant="Font Inter/Body/Bold 16px" style={statStyles.value}>
          {value}
        </Text>
        <Text variant="Font Montserrat/Subtitle/Minimize 2 Medium 10px" style={statStyles.label}>
          {label}
        </Text>
      </Stack>
    );
  },
);

export const SessionSummaryStats = memo(
  ({
    attended,
    clubsNeeded,
    pinsArchived,
  }: {
    attended: number;
    clubsNeeded: number;
    pinsArchived: number;
  }) => {
    const { scale, isTablet } = useScaling();
    return (
      <Stack
        direction="row"
        gap={scale(4)}
        marginTop={isTablet ? undefined : scale(8)}
        paddingX={isTablet ? undefined : scale(18)}
        flexShrink={0}
        align="center">
        <StatCard value={attended} label="ATTENDED" compact={isTablet} />
        <StatCard value={clubsNeeded} label="CLUB(S) NEEDED" compact={isTablet} />
        <StatCard value={pinsArchived} label="PIN(S) ACHIEVED" compact={isTablet} />
      </Stack>
    );
  },
);

const statStyles = StyleSheet.create({
  value: {
    color: colors.Blue,
    textAlign: 'center',
    width: '100%',
  },
  label: {
    color: colors['10'],
    textAlign: 'center',
    width: '100%',
  },
});
